import {
  MetaAddPaymentInfoEvent,
  MetaAddToCartEvent,
  MetaAddToWishlistEvent,
  MetaContent,
  MetaInitiateCheckoutEvent,
  MetaPurchaseEvent,
  MetaViewContentEvent,
} from "src/integrations/meta/types"
import { TrackingCart, TrackingLineItem, TrackingOrder, TrackingProduct } from "src/tracking/types"

function mapContent(product: TrackingProduct | TrackingLineItem): MetaContent {
  return {
    id: product.sku,
    quantity: 1,
  }
}

export function mapProductToMetaAddToWishlistEvent(event_id: string, product: TrackingProduct): MetaAddToWishlistEvent {
  return {
    event_id,
    content_ids: [product.sku],
    contents: [mapContent(product)],
    currency: product.currencyCode,
    value: product.netOfferPrice,
  }
}

export function mapProductToMetaViewContentEvent(event_id: string, product: TrackingProduct): MetaViewContentEvent {
  return {
    event_id,
    content_ids: [product.sku],
    content_type: product.hasVariations ? "product_group" : "product",
    contents: [mapContent(product)],
    currency: product.currencyCode,
    value: product.netOfferPrice,
  }
}

export function mapLineItemToMetaAddToCartEvent(event_id: string, lineItem: TrackingLineItem): MetaAddToCartEvent {
  return {
    event_id,
    content_ids: [lineItem.sku],
    content_type: lineItem.hasVariations ? "product_group" : "product",
    contents: [mapContent(lineItem)],
    currency: lineItem.currencyCode,
    value: lineItem.netOfferPrice,
  }
}

export function mapCartToMetaInitiateCheckoutEvent(event_id: string, cart: TrackingCart): MetaInitiateCheckoutEvent {
  return {
    event_id,
    content_ids: cart.items.map((item) => item.sku),
    contents: cart.items.map(mapContent),
    currency: cart.currencyCode,
    num_items: cart.items.reduce((sum, item) => sum + item.quantity, 0),
    value: cart.netValue,
  }
}

export function mapCartOrderToMetaAddPaymentInfoEvent(event_id: string, cart: TrackingCart): MetaAddPaymentInfoEvent {
  return {
    event_id,
    content_ids: cart.items.map((item) => item.sku),
    contents: cart.items.map(mapContent),
    currency: cart.currencyCode,
    value: cart.netValue,
  }
}

export function mapOrderToMetaPurchaseEvent(order: TrackingOrder): MetaPurchaseEvent {
  return {
    event_id: order.transactionId,
    content_ids: order.items.map((item) => item.sku),
    content_type: "product",
    contents: order.items.map(mapContent),
    currency: order.currencyCode,
    num_items: order.items.reduce((sum, item) => sum + item.quantity, 0),
    value: order.netValue,
  }
}
